import React from 'react'
import BandeiraFormPageContainer from './BandeiraFormPageContainer'

export class BandeiraFormPage extends React.Component {
  render() {
    return <BandeiraFormPageContainer {...this.props} />
  }
}
